import { lazy } from 'react';

// project imports
import MainLayout from 'MainLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';


import AdminGuard from 'utils/route-guard/AdminGuard';
import EmployeeTable from "EmployeeTable";
import Reports from "Reports";
import MonthlyReports from "MonthlyReports";
import Employee from "Employee";
import Calendar from "views/calendar/index";
import Calendar2 from "calendar";
import AdminClients from "views/admin/Clients";
import AdminActivities from "views/admin/Activities";
import Prices from "views/admin/Prices";
import StopwatchForm from "StopwatchForm";
import TimerTest from "components/TimerTest";
import InviteUsers from "components/InviteUsers";
import Download from 'download';
import OnboardingSettings from 'views/company/OnboardingSettings';
import Subscription from 'components/Subscription';
import Success from 'components/Success';
import Payment from 'components/Payment';

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <StopwatchForm />
        </AuthGuard>
      ),
    },
    {
      path: '/payment',
      element: (
        <AuthGuard>
          <Payment />
        </AuthGuard>
      ),
    },
    {
      path: '/settings',
      element: (
        <AuthGuard>
          <OnboardingSettings />
        </AuthGuard>
      ),
    },
    {
      path: '/success',
      element: (
        <AuthGuard>
          <Success />
        </AuthGuard>
      ),
    },
    {
      path: '/employees',
      element: (
        <AuthGuard>
          <EmployeeTable />
        </AuthGuard>
      ),
    },
    {
      path: '/timer-test',
      element: (
        <AuthGuard>
          <TimerTest />
        </AuthGuard>
      ),
    },
    {
      path: '/reports',
      element: (
        <AuthGuard>
          <Reports />
        </AuthGuard>
      ),
    },
    {
      path: '/employee/:id',
      element: (
        <AuthGuard>
          <Employee />
        </AuthGuard>
      ),
    },
    {
      path: '/tasks',
      element: (
        <AuthGuard>
          <Calendar />
        </AuthGuard>
      ),
    },
    {
      path: '/admin/clients',
      element: (
        <AuthGuard>
          <AdminClients />
        </AuthGuard>
      ),
    },
    {
      path: '/admin/prices',
      element: (
        <AuthGuard>
          <Prices />
        </AuthGuard>
      ),
    },
    {
      path: '/admin/activities',
      element: (
        <AuthGuard>
          <AdminActivities />
        </AuthGuard>
      ),
    },
    {
      path: '/admin/invite',
      element: (
        <AuthGuard>
          <InviteUsers />
        </AuthGuard>
      ),
    },
    {
      path: '/tasks2',
      element: (
        <AuthGuard>
          <Calendar2 />
        </AuthGuard>
      ),
    },
    // {
    //   path: '/monthly-reports',
    //   element: (
    //     <AuthGuard>
    //       <MonthlyReports />
    //     </AuthGuard>
    //   ),
    // },
    // {
    //   path: '/download',
    //   element: (
    //     <AuthGuard>
    //       <Download />
    //     </AuthGuard>
    //   ),
    // },
  ]
};
export default MainRoutes;